import * as React     from "react"
import PropTypes      from "prop-types"
import _              from "lodash"
import { Pie, Bar }   from "react-chartjs-2"
import { injectIntl } from "react-intl"
import RatiosTable    from "../ratios-table"
import ModalChart     from "../modal-chart"
import ExportTable     from "../export-table"

export const CHART_SECTIONS = {
	DOTATION : "CHART_SECTIONS.DOTATION"
}

const PROP_NAMES = { LABEL: "label" }

class DotationComponent extends React.Component {
	constructor(props) {
		super(props)

		this.defaultTitleOptions = { display: true}

		this.pieChartOptions = {
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex   = tooltip.datasetIndex
					const dataIndex      = tooltip.index
					const value          = data.datasets[datasetIndex].data[dataIndex]
					const total          = _.sum(data.datasets[datasetIndex].data)
					const percentage     = total ? _.round(value * 100 / total) : 0
					const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					return `${data.labels[dataIndex]} : ${formattedValue} (${percentage}%)`
				}
			}}
		}

		this.defaultBarChartOptions = {
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true,
						callback: (value, index, values) => (
						this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					)}
				},
				{
					gridLines: { display: false },
					id       : "inhabitants",
					position : "right",
					ticks    : { callback: (value, index, values) => (this.props.intl.formatNumber(value)) }
				}
			]},
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex   = tooltip.datasetIndex
					const dataIndex      = tooltip.index
					const value          = data.datasets[datasetIndex].data[dataIndex]

					if (data.datasets.length === datasetIndex - 1) {
						const total          = _.sum(data.datasets[datasetIndex].data)
						const percentage     = total ? _.round(value * 100 / total) : 0
						const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
						return `${data.datasets[datasetIndex].label} : ${formattedValue} (${percentage}%)`
					} else {
						const formattedValue = this.props.intl.formatNumber(value)
						return `${data.datasets[datasetIndex].label} : ${formattedValue}`
					}
				}
			}}
		}

		this.perInhabitantChartOptions = {
			...this.defaultBarChartOptions
		}

		this.modalTabs = [
			{ id: CHART_SECTIONS.DOTATION, label: "Dotation" }
		]
	}

	render() {
		const loading       = this.props.loading
		const displayCharts = this.props.displayCharts
		const titleOptions  = this._getTitleOptions(this.props)

		return (
			<div style={{ height: "100%", overflow: "auto", width: "100%" }}>
				{!loading && <button className="button is-text" onClick={this.props.onClickShowCharts}>Afficher les graphiques</button>}
				<ExportTable data={this.props.tableData} slug={this.props.slug} id={this.props.id} years={this.props.years} />

				<RatiosTable data={this.props.tableData} years={this.props.years} />

				{displayCharts && (
					<ModalChart
					displayCharts        = {displayCharts}
					onClickHideCharts    = {this.props.onClickHideCharts}
					onClickShowCharts    = {this.props.onClickShowCharts}
					title                = "Dotation"
					tabs                 = {[]}>

					<Pie data={this.props.pieChartData} options={{...this.pieChartOptions, title: titleOptions.pieChart}} />
					<Bar data={this.props.totalChartData} options={{...this.defaultBarChartOptions, title: titleOptions.totalChart}} />
					<Bar data={this.props.perInhabitantChartData} options={{...this.perInhabitantChartOptions, title: titleOptions.perInhabitantChart}} />

					</ModalChart>
				)}
			</div>
		)
	}

	_getTitleOptions = (props) => {
		const defaultTitleOptions = { display: true }
		return {
			perInhabitantChart: {
				...defaultTitleOptions,
				text: 'Dotation par habitant'
			},
			pieChart: {
				...defaultTitleOptions,
				text: 'Dotation'
			},
			totalChart: {
				...defaultTitleOptions,
				text: 'Dotation'
			}
		}
	}
}

export default injectIntl(DotationComponent)

DotationComponent.propTypes = {
	displayCharts       : PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.oneOf([CHART_SECTIONS.FISCALITE])
	]).isRequired,
	loading             : PropTypes.bool.isRequired,
	onClickHideCharts   : PropTypes.func.isRequired,
	onClickShowCharts   : PropTypes.func.isRequired,
	tableData           : PropTypes.array.isRequired,
	years               : PropTypes.arrayOf(PropTypes.number).isRequired
}


// WEBPACK FOOTER //
// ./src/component/ratios/dotation/dotation-component.js